import storage from './storage';
import { generateId } from '../utils/uuid';

function key(userId) {
  return userId ? `crm_lead_comments_u${userId}` : 'crm_lead_comments';
}

function slugCompact(name) {
  return String(name || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '');
}

function parseMentions(text, authUsers = []) {
  const ids = new Set();
  const t = text || '';

  const re = /@([\w.\-]+)/g;
  let m;
  while ((m = re.exec(t))) {
    const slug = m[1].toLowerCase();
    const u = authUsers.find(
      a => (a.name || '').toLowerCase().replace(/\s+/g, '') === slug
        || (a.email || '').split('@')[0].toLowerCase() === slug,
    );
    if (u) ids.add(u.id);
  }

  for (const u of authUsers) {
    if (!u?.id) continue;
    const compact = slugCompact(u.name);
    if (compact.length >= 4) {
      const esc = compact.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const reN = new RegExp(`@${esc}(?![\\w.-])`, 'i');
      if (reN.test(t)) ids.add(u.id);
    }
    const first = (u.name || '').trim().split(/\s+/)[0];
    if (first && first.length >= 3) {
      const escF = first.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const reF = new RegExp(`@${escF}(?![\\w.-])`, 'i');
      if (reF.test(t)) ids.add(u.id);
    }
  }

  return [...ids];
}

export const leadCommentsService = {
  getThread(userId, leadId) {
    const all = storage.get(key(userId), {});
    return Array.isArray(all[String(leadId)]) ? all[String(leadId)] : [];
  },
  saveThread(userId, leadId, thread) {
    const all = { ...storage.get(key(userId), {}) };
    all[String(leadId)] = thread;
    storage.set(key(userId), all);
  },
  add(userId, leadId, { text, authorId, authorName, authUsers = [] }) {
    const thread = this.getThread(userId, leadId);
    const mentions = parseMentions(text, authUsers);
    const entry = {
      id: generateId(),
      text: text.trim(),
      authorId,
      authorName,
      createdAt: new Date().toISOString(),
      mentions,
    };
    this.saveThread(userId, leadId, [entry, ...thread]);
    return entry;
  },
};
